module.exports = __webpack_public_path__ + "static/img/ic_logo_jns_menu.997d3eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_2/ic_logo_jns_menu.png
// module id = BDGa
// module chunks = 0